import mod from "-!./Edit.js?vue&type=script&lang=js&"; export default mod; export * from "-!./Edit.js?vue&type=script&lang=js&"